import moment from 'moment';
import 'moment/min/locales';

const locale=$('html').attr('lang');
moment.locale(locale);

window.moment = moment

export default moment;